export default __webpack_public_path__ + "static/media/NoData.af2ffc5c.svg";